import { IClinicIncentiveModel, ClinicIncentiveModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ClinicIncentiveService {

    private static baseUrl: string = '/api/clinicincentive';

    static tags = {
        updateClinicIncentive: "updateClinicIncentive",
        deleteClinicIncentive: "deleteClinicIncentive",
        importClinicIncentives: "importClinicIncentives",
    }


    /**
     * Sends a file to Incentive Api to upload a list of new Clinic Incentives.
     * @param data FormData that needs to have a File object appended to FormData prior to calling this service method
     * i.e. formData.append('File', *file*);
     * @param options Service Method Options
     * @returns Promise
     */
    static importClinicIncentives = (data: FormData, options?: ServiceMethodOptions): Promise<void> => {
        return trackPromise(new Promise<void>((resolve, reject) => {
            fetch(`${this.baseUrl}/import`, {
                method: 'POST',
                body: data
            }).then((response) => {
                if (!response.ok)
                    throw response;

                ServiceHelper.showSuccess("Import successful", options);
                resolve();

            }).catch((err) => {
                ServiceHelper.showError("Failed to import incentives.");
                reject(err);
            })

        }), this.tags.importClinicIncentives)
    }

    /**
     * Adds or Updates Clinic Incentives
     * @param data Clinic Incentive to update
     * @param options Service Method Options
     * @returns ClinicIncentiveModel
     */
    static upsertClinicIncentive = (data: ClinicIncentiveModel, options?: ServiceMethodOptions): Promise<ClinicIncentiveModel> => {
        return trackPromise(new Promise<ClinicIncentiveModel>((resolve, reject) => {
            http(`${this.baseUrl}`).post<IClinicIncentiveModel>(data)
                .then((response) => {
                    ServiceHelper.showSuccess("Clinic Incentive updated", options);
                    resolve(new ClinicIncentiveModel(response));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to update Clinic Incentive.", options);
                    reject(err);
                })
        }), this.tags.updateClinicIncentive);
    }

    /**
     * Deletes Clinic Incentive by Id
     * @param id Clinic Incentive Id
     * @param options Service Method Options
     * @returns boolean on success
     */
    static deleteClinicIncentive = (id: number, options?: ServiceMethodOptions): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/${id}`).delete()
                .then(() => {
                    ServiceHelper.showSuccess("Clinic Incentive has been deleted", options);
                    resolve(true);
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to delete Clinic Incentive.", options);
                    reject(err);
                })
        }), this.tags.deleteClinicIncentive);
    }
}
